module.exports = __webpack_public_path__ + "img/pic-s5-realizujaca-marzenia.png";